"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const text_1 = require("./text");
const keautils_1 = require("keautils");
const keautils_2 = require("keautils");
const autoFiltro_1 = require("../filtros/autoFiltro");
const filtroInvalido_1 = require("../components/filtroInvalido");
const helpers_1 = require("./helpers");
/**Representa una fila del grid, despues de haber obtenido los valores con el getData */
/**Obtiene el filtro efectivo de la columna, si el filtro no esta definido en la columna se usa el selector getAutoFiltro */
function getFiltro(data, getData, filter) {
    const x = () => React.createElement("span", null);
    if (filter) {
        return filter;
    }
    else {
        const dataSync = data;
        const defaultFilter = {
            component: filtroInvalido_1.FiltroInvalidoComp,
            filter: () => true
        };
        const filtro = autoFiltro_1.getAutoFiltro(dataSync, getData) || defaultFilter;
        return filtro;
    }
}
exports.getFiltro = getFiltro;
/**
 * Para una lista de elementos, obtiene la misma lista de elementos pero obtieniendo cada uno de los datos de las columnas con sus respectivos getCell y los datos de la busqueda,
 * esta estructura de datos se usa para acelerar las búsquedas ya que estos valores se tendran que calcular sólo cuando cambien los items, en lugar de cada vez que se realize una búsqueda
 * @param data
 */
function getItemCellData(data, columnas) {
    const ret = data.map(x => {
        const cell = keautils_2.mapObject(columnas, (value, key) => {
            const cell = value.cell(x);
            const string = cell.string;
            return {
                data: cell.data,
                string: string || text_1.cellToText(cell.data),
                style: cell.style,
                view: cell.view
            };
        });
        const textSearch = keautils_2.enumObject(cell).map(x => x.value.string).join(" ");
        return {
            cell,
            original: x,
            textSearch
        };
    });
    return ret;
}
exports.getItemCellData = getItemCellData;
/**Aplica los filtros de columnas y el orden a los datos
 * @param searchFunc Función que se utiliza en la búsqueda por texto
*/
function filtrarOrdenar(data, filtroOrden, columnas) {
    let ret = data;
    ret = filtroBusqueda(ret, filtroOrden.busqueda);
    ret = filtrarPorColumnas(ret, filtroOrden.columna, columnas);
    if (filtroOrden.orden) {
        ret = ordenar(ret, filtroOrden.orden.orden, filtroOrden.orden.columna);
    }
    return ret;
}
exports.filtrarOrdenar = filtrarOrdenar;
/**Convierte una columna del grid a una columna FiltroOrdenColumna */
function gridColumnToFiltroOrdenColumn(data, value) {
    return {
        cell: value.cell,
        filtro: (getFiltro(data, (x) => value.cell(x).data, value.filter)).filter,
    };
}
exports.gridColumnToFiltroOrdenColumn = gridColumnToFiltroOrdenColumn;
/**Ordena un conjunto de datos de un grid */
function ordenar(data, orden, column) {
    const getData = (x) => x.cell[column].data;
    const sortFunc = (a, b) => (helpers_1.compare(a, b)) * (orden == "asc" ? 1 : -1);
    const rowSortFunc = (a, b) => sortFunc(getData(a), getData(b));
    return [...data].sort(rowSortFunc);
}
/**Aplica los filtros por columna */
function filtrarPorColumnas(data, filtros, columnas) {
    //Función que aplica un filtro:
    const aplicarFiltro = (filtro, data) => {
        const columna = columnas[filtro.key];
        const pasaFiltro = (x) => {
            const cell = x.cell[filtro.key];
            const data = cell.data;
            const string = cell.string;
            return columna.filtro(data, filtro.datos || {}, string);
        };
        return data.filter(pasaFiltro);
    };
    /**Aplicamos todos los filtros: */
    const ret = keautils_2.enumObject(filtros, (key, value) => (Object.assign({}, value, { key }))).reduce((datos, filtro) => aplicarFiltro(filtro, datos), data);
    return ret;
}
/**Aplica el filtro de la búsqueda por texto */
function filtroBusqueda(items, busqueda) {
    if (!busqueda)
        return items;
    return items.filter(x => keautils_1.search(busqueda, x.textSearch));
}



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/simpleGrid/filtrarOrdenar.js
// module id = 213
// module chunks = 0